module.exports = __webpack_public_path__ + "img/chickenbbq20261710.6a363b03.jpg";